import React, { useState, useRef } from 'react';
import PropTypes, { string } from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';

import Icon from '../../Icon';
import ClickableElement from '../../ClickableElement';
import InfoPopover from '../../InfoPopover';
import { COLORS } from '../../../constants/styles';
import styles from './index.styl';

const SurveyListItem = ({
  list,
  heading,
  title,
  active,
  status,
  onClick,
  subtitle,
  description,
  date,
}) => {
  const [isShownTooltip, toggleTooltip] = useState(false);
  const anchor = useRef(null);

  const handleTooltipClick = e => {
    e.stopPropagation();
    toggleTooltip(true);
  };

  const handleTooltipClose = e => {
    e.stopPropagation();
    toggleTooltip(false);
  };

  const handleTooltipCloseAndOpenDetails = () => {
    toggleTooltip(false);
  };

  return (
    <div
      styleName={classNames('survey-card', 'header', {
        'survey-card--active': active,
      })}
      className="relative"
      onClick={onClick}
      onMouseDown={handleTooltipCloseAndOpenDetails}
    >
      <div className={styles.container}>
        <Icon styleName="icon" name="up-surveys" size={32} />
        <div styleName="content">
          <div styleName="heading">
            <span styleName="text--heading">{heading}</span>
            <div className="flex items-center" ref={anchor}>
              <span styleName="text--title">{title}</span>
              {Boolean(description || list) && (
                <ClickableElement
                  onClick={handleTooltipClick}
                  className="ml1"
                  ariaLabel="info-default"
                >
                  <Icon
                    name="info-default"
                    size={16}
                    style={{ fill: COLORS.bluePrimary }}
                  />
                </ClickableElement>
              )}
            </div>
            {subtitle && <div styleName="text--subtitle">{subtitle}</div>}
            {date && <div styleName="text--date">{date}</div>}
          </div>
          {status && <div styleName="text--subtitle">{status}</div>}
        </div>
      </div>
      <InfoPopover
        onClose={handleTooltipClose}
        isOpen={isShownTooltip}
        description={description}
        anchorEl={anchor.current}
        list={list}
      />
    </div>
  );
};

SurveyListItem.propTypes = {
  heading: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  status: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string,
  ]),
  active: PropTypes.bool,
  onClick: PropTypes.func,
  list: PropTypes.array,
  date: string,
};

export default CSSModules(SurveyListItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveyListItem/index.jsx